exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-login-v3:before {\n  position: fixed;\n  top: 0;\n  left: 0;\n  content: \"\";\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFE4EAEC', endColorstr='#FFEEEEEE', GradientType=0);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/lib/jenkins/workspace/Partners-Pipeline/node_modules/postcss-loader?{"ident":"postcss"}!/var/lib/jenkins/workspace/Partners-Pipeline/src/assets/css/login-v3.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/login-v3.css
// module chunks = styles